import ResourceApi from '../ResourceApi';

const PullsResource = {
  index: async (params) => (await ResourceApi.get('/resource/pulls', params)).data,
  cycle: async (params) => (await ResourceApi.get('/resource/pulls/cycle-time', params)).data,
};

export default PullsResource;
